import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "planner-cal-container" }
const _hoisted_2 = { class: "planner-cal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "vfm-modal-title" }, " Add New Event ", -1)
const _hoisted_4 = { class: "vfm-modal-content" }
const _hoisted_5 = {
  key: 0,
  class: "side-panel"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Recommendations")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_planner_calendar_event = _resolveComponent("planner-calendar-event")!
  const _component_edit_milestone_form = _resolveComponent("edit-milestone-form")!
  const _component_edit_assignment_form = _resolveComponent("edit-assignment-form")!
  const _component_extend_deadline_form = _resolveComponent("extend-deadline-form")!
  const _component_v_dropdown = _resolveComponent("v-dropdown")!
  const _component_full_calendar = _resolveComponent("full-calendar")!
  const _component_planner_event_create_form = _resolveComponent("planner-event-create-form")!
  const _component_vue_final_modal = _resolveComponent("vue-final-modal")!
  const _component_planner_errors = _resolveComponent("planner-errors")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_full_calendar, {
        ref: "calendar",
        options: _ctx.calendarOptions
      }, {
        eventContent: _withCtx((arg) => [
          _createVNode(_component_v_dropdown, {
            triggers: ['click'],
            placement: "auto",
            "auto-boundary-max-size": ""
          }, {
            popper: _withCtx(() => [
              (_ctx.selectedMilestone)
                ? (_openBlock(), _createBlock(_component_edit_milestone_form, {
                    key: 0,
                    "calendar-event": _ctx.selectedMilestone.event,
                    milestone: _ctx.selectedMilestone.milestone,
                    onRemove: _ctx.handleRemoveEvent,
                    onSubmit: _ctx.handleEventUpdate
                  }, null, 8, ["calendar-event", "milestone", "onRemove", "onSubmit"]))
                : _createCommentVNode("", true),
              (_ctx.selectedAssignment && !_ctx.selectedAssignment.element.published)
                ? (_openBlock(), _createBlock(_component_edit_assignment_form, {
                    key: 1,
                    "calendar-event": _ctx.selectedAssignment.event,
                    assignment: _ctx.selectedAssignment.assignment,
                    "available-assignments": _ctx.assignableContent,
                    onRemove: _ctx.handleRemoveEvent,
                    onSubmit: _ctx.handleEventUpdate
                  }, null, 8, ["calendar-event", "assignment", "available-assignments", "onRemove", "onSubmit"]))
                : _createCommentVNode("", true),
              (_ctx.selectedAssignment && _ctx.selectedAssignment.element.published)
                ? (_openBlock(), _createBlock(_component_extend_deadline_form, {
                    key: 2,
                    "calendar-event": _ctx.selectedAssignment.event,
                    assignment: _ctx.selectedAssignment.assignment,
                    onRemove: _ctx.handleRemoveEvent,
                    onSubmit: _ctx.handleEventUpdate
                  }, null, 8, ["calendar-event", "assignment", "onRemove", "onSubmit"]))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_planner_calendar_event, {
                event: arg.event
              }, null, 8, ["event"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["options"]),
      _createElementVNode("div", null, [
        _createVNode(_component_vue_final_modal, {
          modelValue: _ctx.showModal,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showModal) = $event)),
          classes: "vfm-modal-container",
          "content-class": "vfm-modal-content"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              (_ctx.newEvent)
                ? (_openBlock(), _createBlock(_component_planner_event_create_form, {
                    key: 0,
                    "initial-start-date": _ctx.newEvent.publishDate,
                    "initial-end-date": _ctx.newEvent.dueDate,
                    "content-options": _ctx.assignableContent,
                    onSubmit: _ctx.handleEventCreate
                  }, null, 8, ["initial-start-date", "initial-end-date", "content-options", "onSubmit"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    (_ctx.hasErrors)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_planner_errors, {
            errors: _ctx.errors,
            onShowDetails: _ctx.handleShowErrorDetails
          }, null, 8, ["errors", "onShowDetails"])
        ]))
      : _createCommentVNode("", true)
  ]))
}